import type { Employee } from '../services/httpServices/employeeService';

/** Human-friendly employee name with sensible fallbacks. */
export function employeeDisplayName(employee?: Partial<Employee> | null): string {
  if (!employee) return '';
  const full = `${employee.firstName || ''} ${employee.lastName || ''}`.trim();
  return full || employee.name || 'Employee';
}

/** Up to two uppercase initials for avatar placeholders. */
export function employeeInitials(employee?: Partial<Employee> | null): string {
  const name = employeeDisplayName(employee);
  const parts = name.replace(/[^A-Za-z\s]/g, '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}
